export const c_effect = {
  c_atk    : ['skl_dmg', 'str', 'crt_rt', 'crt_dmg', 'frc_stk', 'enr'],
  c_pns    : ['ovd_pns', 'brk_pns', 'psn_pns', 'brn_pns', 'frz_pns', 'prl_pns',
              'bln_pns', 'stn_pns', 'crs_pns','bg_pns' , 'slp_pns'],
  c_dfn    : ['hp', 'dfn', 'shl_prp'],
  c_el_rs  : ['flm_rs', 'wtr_rs', 'wnd_rs', 'lgh_rs', 'shd_rs'],
  c_sp     : ['skl_prp', 'skl_chr', 'skl_hst', 'bf_tm', 'gg_acl', 'gg_inh'],
  c_hl     : ['rcv_ptn', 'hl'],
  c_drg    : ['shs_prp', 'drg_dmg', 'drg_tm', 'drg_clw'],
  c_dbf_rs : ['afl_grd', 'psn_rs', 'brn_rs', 'frz_rs', 'prl_rs',
              'bln_rs', 'stn_rs', 'crs_rs', 'bg_rs', 'slp_rs'],
  c_rc_rs  : ['hmd_rs', 'hbr_rs', 'hmr_rs', 'hjp_rs', 'hzd_rs',
              'md_rs', 'br_rs', 'mr_rs', 'jp_rs', 'zd_rs'],
  c_other  : ['exp']
}

export const effect = {
  flm_rs      : ['flm_rs'],
  wtr_rs      : ['wtr_rs'],
  wnd_rs      : ['wnd_rs'],
  lgh_rs      : ['lgh_rs'],
  shd_rs      : ['shd_rs'],

  afl_grd     : ['afl_grd'],
  psn_rs      : ['psn_rs'],
  brn_rs      : ['brn_rs'],
  frz_rs      : ['frz_rs'],
  prl_rs      : ['prl_rs'],
  bln_rs      : ['bln_rs'],
  stn_rs      : ['stn_rs'],
  crs_rs      : ['crs_rs'],
  bg_rs       : ['bg_rs'],
  slp_rs      : ['slp_rs'],

  hmd_rs      : ['hmd_rs'],
  md_rs       : ['md_rs'],
  hbr_rs      : ['hbr_rs'],
  br_rs       : ['br_rs'],
  hmr_rs      : ['hmr_rs'],
  mr_rs       : ['mr_rs'],
  hjp_rs      : ['hjp_rs'],
  jp_rs       : ['jp_rs'],
  hzd_rs      : ['hzd_rs'],
  zd_rs       : ['zd_rs'],

  hfl_str     : ['hfl', 'str'],
  hfl_dfn     : ['hfl', 'dfn'],
  hfl_hl      : ['hfl', 'hl'],
  hfl_skl_dmg : ['hfl', 'skl_dmg'],
  hfl_crt_rt  : ['hfl', 'crt_rt'],
  hfl_crt_dmg : ['hfl', 'crt_dmg'],

  h70_str     : ['h70', 'str'],
  h70_dfn     : ['h70', 'dfn'],
  h70_hl      : ['h70', 'hl'],
  h70_skl_dmg : ['h70', 'skl_dmg'],
  h70_crt_rt  : ['h70', 'crt_rt'],
  h70_crt_dmg : ['h70', 'crt_dmg'],

  str_dbb     : ['dbb', 'str'],
  hl_dbb      : ['dbb', 'hl'],
  enr_dbb     : ['dbb', 'enr'],
  crt_dmg_dbb : ['dbb', 'crt_dmg'],

  lst_ofn     : ['lst', 'str'],
  lst_dfn     : ['lst', 'dfn'],
  lst_rcv     : ['lst', 'rcv_ptn'],
  lst_crt_rt  : ['lst', 'crt_rt'],
  rsl_ofn     : ['rsl', 'str'],

  flr_str     : ['flr', 'str'],
  flr_dvs     : ['flr', 'crt_rt'],
  hts_elu     : ['hts', 'enr'],

  drg_dmg     : ['drg_dmg'],
  drg_tm      : ['drg_tm'],
  drg_clw     : ['drg_clw'],

  skl_prp     : ['skl_prp'],
  shs_prp     : ['shs_prp'],
  enr_prp     : ['enr_prp', 'enr'],
  shl_prp     : ['shl_prp'],

  skl_hst     : ['skl_hst'],
  unt_hst     : ['unt', 'skl_hst'],
  stk_hst     : ['stk', 'skl_hst'],
 
  frc_stk     : ['frc_stk'],
  frc_chr     : ['stk', 'skl_chr'],

  ovd_pns     : ['ovd_pns'],
  brk_pns     : ['brk_pns'],
  psn_pns     : ['psn_pns'],
  brn_pns     : ['brn_pns'],
  frz_pns     : ['frz_pns'],
  prl_pns     : ['prl_pns'],
  bln_pns     : ['bln_pns'],
  stn_pns     : ['stn_pns'],
  crs_pns     : ['crs_pns'],
  bg_pns      : ['bg_pns'],
  slp_pns     : ['slp_pns'],

  slyr_str    : ['slyr', 'str'],
  stkr_str    : ['stkr', 'str'],

  gg_acl      : ['gg_acl'],
  gg_inh      : ['gg_inh'],

  hp          : ['hp'],
  skl_dmg     : ['skl_dmg'],
  crt_rt      : ['crt_rt'],
  crt_dmg     : ['crt_dmg'],
  rcv_ptn     : ['rcv_ptn'],
  bf_tm       : ['bf_tm'],

  exp_1       : ['exp'],
  exp_2       : ['exp'],
  exp_3       : ['exp']
}

export const c_weapon = ['sword', 'blade', 'dagger', 'axe', 'lance', 'bow', 'wand', 'staff']
export const c_element = ['flame', 'water', 'wind', 'light', 'shadow']